import { render, staticRenderFns } from "./sidebare.vue?vue&type=template&id=08fcabab&"
import script from "./sidebare.vue?vue&type=script&lang=js&"
export * from "./sidebare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports